import dayjs from "dayjs";
import DocumentDO = App.Data.Explorer.DocumentDO;

/**
 * Y > Bud > Y-1 > Y-n > everything else
 */
const comparisionDataToNumber = (
	label: string,
	derivedDocument: DocumentDO
) => {
	const yoyMatches = {
		"ΔY-": undefined,
		"Y-": undefined,
		ΔBud: 0.5,
		Bud: 0.5,
	};

	if (
		label === "Y" ||
		label === derivedDocument?.date_comparison?.comparisonLabel
	) {
		return 0;
	}

	for (const [key, value] of Object.entries(yoyMatches)) {
		if (label.startsWith(key)) {
			return value ?? parseInt(label.slice(key.length));
		}
	}

	for (const customPeriod of derivedDocument?.date_comparison?.customPeriods ??
		[]) {
		if (label === customPeriod.name || label === `Δ${customPeriod.name}`) {
			return dayjs(customPeriod.period.from_parsed).unix();
		}
	}

	return Number.MAX_SAFE_INTEGER;
};

export function orderComparisonData<T>(
	derivedDocument: DocumentDO,
	comparisonData: T[],
	getValue: (key: T) => string
): T[] {
	return comparisonData.toSorted(
		(a, b) =>
			comparisionDataToNumber(getValue(a), derivedDocument) -
			comparisionDataToNumber(getValue(b), derivedDocument)
	);
}
